






















import Vue, { PropType } from 'vue';
import { mapActions, mapGetters } from 'vuex';
import { ErrorManager } from '@/models/error';
import { WorkgroupFieldError } from '@/models';

export default Vue.extend({
  name: 'WorkgroupPicker',

  model: {
    prop: 'value',
    event: 'input'
  },

  props: {
    value: [Number, Object],

    label: {
      type: String,
      default: 'Workgroups'
    },

    externalErrorMessage: {
      type: [Array, Object] as PropType<string[] | WorkgroupFieldError>,
      default: () => []
    }
  },

  data() {
    return {
      lazyValue: this.value,
      search: '',
      errorMessage: '',
      workgroupLoading: false
    };
  },

  watch: {
    value: {
      handler(val: any) {
        this.lazyValue = val;
      },
      immediate: true
    }
  },

  computed: {
    ...mapGetters({
      workgroups: 'workgroup/getWorkgroups'
    }),

    internalValue: {
      get(): any {
        return this.lazyValue;
      },
      set(val: any) {
        this.lazyValue = val;
        this.$emit('input', val);
      }
    },

    customAttrs(): object {
      return this.$attrs;
    },

    errorMessageList(): string[] {
      let errorList: string[] = [];
      if (!(this.externalErrorMessage instanceof WorkgroupFieldError)) {
        errorList = this.externalErrorMessage;
      }
      if (this.errorMessage) {
        errorList.push(this.errorMessage);
      }

      return errorList;
    }
  },

  mounted() {
    // fetch all workgroups
    this.workgroupLoading = true;
    this.fetchWorkgroups()
      .catch(error => {
        this.errorMessage = ErrorManager.extractApiError(error);
      })
      .finally(() => (this.workgroupLoading = false));
  },

  methods: {
    ...mapActions({
      fetchWorkgroups: 'workgroup/fetchWorkgroups'
    })
  }
});
